import { useContext } from "react";
import { UserContext } from "../context";

export function useUserContext() {
  const context = useContext(UserContext);
  return context;
}
